module.exports = __webpack_public_path__ + "3795052858a50e658c664f9d4a45a4b9.png";